import React from "react";
import useLogin from "@common/components/hooks/useLogin";
import { Controller } from "react-hook-form";
import SignaturePad from "react-signature-canvas";
import { Button, Label } from "semantic-ui-react";

const SignatureComponent = ({ sigRef, control, errors }) => {
  const handleSignatureEnd = (field) => {
    const dataUrl = sigRef.current.getTrimmedCanvas().toDataURL("image/png");
    field.onChange(dataUrl);
  };

  const clearSignature = (field) => {
    if (sigRef.current) {
      sigRef.current.clear();
      field.onChange("");
    }
  };

  const [{ isInReadMode }] = useLogin();

  return (
    <>
      <p>
        <b>Signature</b>
      </p>
      <Controller
        name="signature"
        control={control}
        render={({ field }) => {
          return (
            <>
              <SignaturePad
                ref={sigRef}
                penColor="black"
                canvasProps={{ className: "signature-pad" }}
                onEnd={() => handleSignatureEnd(field)}
              />
              <Button
                className="my-1"
                type="button"
                disabled={isInReadMode}
                onClick={() => clearSignature(field)}
              >
                Clear Signature
              </Button>
            </>
          );
        }}
      />
      {errors.signature && (
        <Label pointing="above" prompt>
          {errors.signature.message}
        </Label>
      )}
    </>
  );
};

export default SignatureComponent;
